import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=60d9cc23"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports